import { render, staticRenderFns } from "./LessonForm.vue?vue&type=template&id=0ee10d54"
import script from "./LessonForm.vue?vue&type=script&lang=js"
export * from "./LessonForm.vue?vue&type=script&lang=js"
import style0 from "./LessonForm.vue?vue&type=style&index=0&id=0ee10d54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports